import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const signersWrapper = () => css`
  width: 100%;
`;

export const signerNameWrapper = () => css`
  min-width: 0;
`;

export const signerItemDivider: ThemedFunctor = ({ theme }) => css`
  border-top: 1px solid ${theme.palettes.neutral[100]};
`;
